import { render } from "./EditProduct.vue?vue&type=template&id=e020a924&scoped=true&ts=true"
import script from "./EditProduct.vue?vue&type=script&lang=ts"
export * from "./EditProduct.vue?vue&type=script&lang=ts"

import "./EditProduct.vue?vue&type=style&index=0&id=e020a924&lang=css"
import "./EditProduct.vue?vue&type=style&index=1&id=e020a924&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e020a924"]])

export default __exports__